module.exports = __webpack_public_path__ + "img/setter.ba8a0792.svg";